export interface EntertainmentVideo {
  id: number,
  influencerId: number,
  status: EntertainmentVideoStatus,
  declinedReason: string | null,
  reviewedAt: string | null,
  publishedAt: string | null,
  declineHistories: Array<DeclineHistory>,
  genders: Array<string>,
  tags: Array<string>,
  audioType: EntertainmentVideoAudioType | null,
  isProductReview: boolean,
  publishedFrom: string | null,
  publishedUntil: string | null,
  publishedCountries: Array<string>,
  publishedError: string | null,
  deliverableId: number,
  name: string,
  title: string,
  createdAt: string,
  updatedAt: string
}

export interface EntertainmentVideoItemBlank {
  sku: string,
  itemUrl: string,
  imageUrl: string,
  isSimilar: boolean
}

export interface EntertainmentVideoItem extends EntertainmentVideoItemBlank {
  id: number,
  entertainmentVideoId: number
}

export interface EntertainmentVideoMedia {
  id: number,
  entertainmentVideoId: number,
  url: string,
  contentType: string,
  metadata: never,
  mediaContentId: never,
  processStatus: never,
  thumbnailUrl: string | null
}

export interface FullEntertainmentVideo {
  entertainmentVideo: EntertainmentVideo,
  items: Array<EntertainmentVideoItem>,
  media: EntertainmentVideoMedia | null
}

export enum EntertainmentVideoStatus {
  DRAFT = 'DRAFT',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  PUBLISHING = 'PUBLISHING',
  PUBLISH_FAILED = 'PUBLISH_FAILED',
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHING = 'UNPUBLISHING',
  UNPUBLISHED = 'UNPUBLISHED',
  UNPUBLISH_FAILED = 'UNPUBLISH_FAILED'
}

export enum EntertainmentVideoAudioType {
  MUTED = 'MUTED',
  MUSIC = 'MUSIC',
  SPEECH = 'SPEECH',
  MUSIC_AND_SPEECH = 'MUSIC_AND_SPEECH',
}

export interface DeclineHistory {
  text: string,
  date: string
}
